import { hasAuthoritativeWorkflowState, workflowRunState } from './workflowRunProjectionState.js';

export const THINKING_STAGE_LABELS = {
  analysis: '思考中',
  orchestration: '处理中',
  generating: '生成回复中',
  pending: '等待执行',
  running: '执行中',
  waiting_user: '等待确认',
  blocked: '已阻塞',
  cancelled: '已取消',
  failed: '生成失败',
  partial: '部分完成',
  completed: '已完成',
};

export const COMPLETED_STATUS = new Set(['completed', 'done', 'finished', 'succeeded']);
export const FAILED_STATUS = new Set(['failed', 'error']);
export const RUNNING_STATUS = new Set(['running', 'queued', 'searching']);
export const WAITING_USER_STATUS = new Set(['waiting_user', 'waiting_for_user', 'waiting-user', 'asked', 'question']);
export const BLOCKED_STATUS = new Set(['blocked']);
export const CANCELLED_STATUS = new Set(['cancelled', 'canceled']);
export const PARTIAL_STATUS = new Set(['partial', 'degraded']);

export function normalizeStatus(status) {
  return String(status || '').toLowerCase().trim();
}

export function hasWaitingUserStatus(item) {
  return hasItemStatus(item, WAITING_USER_STATUS);
}

export function hasFailedStatus(item) {
  return hasItemStatus(item, FAILED_STATUS);
}

export function hasBlockedStatus(item) {
  return hasItemStatus(item, BLOCKED_STATUS);
}

export function hasCancelledStatus(item) {
  return hasItemStatus(item, CANCELLED_STATUS);
}

export function hasPartialStatus(item) {
  return hasItemStatus(item, PARTIAL_STATUS);
}

export function hasRunningStatus(item) {
  return hasItemStatus(item, RUNNING_STATUS);
}

function hasItemStatus(item, acceptedStatuses) {
  if (hasAuthoritativeWorkflowState(item)) {
    return acceptedStatuses.has(normalizeStatus(workflowRunState(item)));
  }
  const record = Object.assign({}, item);
  const agentStatus = Object.assign({}, record.agentStatus);
  return acceptedStatuses.has(normalizeStatus(agentStatus.status));
}
